import camelcaseKeys from "../../camelcase-keys";
import { BaseResponse } from "../models/base-response";
import { ApiResponse } from "./api-response";

export class JsonApiResponse<T extends BaseResponse> {
  private response: T | null = null;

  protected success: boolean;
  protected _statusCode: number;
  protected body: string;

  constructor(apiResponse: ApiResponse) {
    this.success = apiResponse.success;
    this._statusCode = apiResponse.httpStatusCode;
    this.body = apiResponse.body;

    if (apiResponse.success && !!apiResponse.body) {
      // The api randomly either returns the response as the root object or as a property called Response
      // and sometimes camel case and sometimes pascal case
      const parsedResponse = JSON.parse(apiResponse.body);
      const parsedResponseCamelCase = camelcaseKeys(parsedResponse, {
        pascalCase: true,
        deep: true,
        preserveConsecutiveUppercase: true,
      });
      this.response = (
        parsedResponseCamelCase?.Response
          ? parsedResponseCamelCase.Response
          : parsedResponseCamelCase
      ) as T;
    }
  }

  public tryGetSuccessResponse(): [boolean, T | undefined] {
    if (this.success && !(this.response == null)) {
      return [true, this.response];
    }

    this.response = null;
    return [false, undefined];
  }

  get statusCode(): number {
    return this._statusCode;
  }
}
